import { Badge } from "@chakra-ui/react";
import { isAdmin } from "../../auth/lib/roles";

export const ROLE_LABEL = {
  user: "Médico",
  admin: "Administrador",
  superadmin: "Superadministrador",
};

const ROLE_COLOR = { user: "gray", admin: "brand", superadmin: "brand" };

// "aaaa-mm-dd" → "dd/mm/aaaa" (sem passar por Date, para não deslocar o dia pelo fuso)
export const formatarData = (iso) => iso.split("-").reverse().join("/");

export function RoleBadge({ role }) {
  return (
    <Badge variant="statusSubtle" colorScheme={ROLE_COLOR[role] ?? "gray"}>
      {ROLE_LABEL[role] ?? role}
    </Badge>
  );
}

export function AccountStatusBadge({ ativo }) {
  return (
    <Badge variant="statusSubtle" colorScheme={ativo ? "success" : "danger"}>
      {ativo ? "Ativa" : "Desativada"}
    </Badge>
  );
}

export function EmailBadge({ verified }) {
  return (
    <Badge variant="statusSubtle" colorScheme={verified ? "success" : "warning"}>
      {verified ? "E-mail verificado" : "E-mail não verificado"}
    </Badge>
  );
}

// Plano calculado pelo backend (domain.User.Plan) com a data que importa para o admin.
export function AccessBadge({ row }) {
  if (isAdmin(row)) {
    return (
      <Badge variant="statusSubtle" colorScheme="success">
        Sem cobrança
      </Badge>
    );
  }
  if (!row.has_access) {
    return (
      <Badge variant="statusSubtle" colorScheme="danger">
        Só leitura
      </Badge>
    );
  }
  if (row.plan === "free") {
    return (
      <Badge variant="statusSubtle" colorScheme="brand">
        Plano grátis
      </Badge>
    );
  }
  if (row.assinatura_ate && row.assinatura_ate >= row.trial_ate) {
    return (
      <Badge variant="statusSubtle" colorScheme="success">
        Assinante até {formatarData(row.assinatura_ate)}
      </Badge>
    );
  }
  return (
    <Badge variant="statusSubtle" colorScheme="warning">
      Teste até {formatarData(row.trial_ate)}
    </Badge>
  );
}
